import { RateItem } from "../../models";


/**
 * Represents a change to a row in a rate item grid, including column values and metadata.
 */
export class RateItemRowChange {

  /**
   * The row index where the change occurred.
   */
  public row: number = 0;

  /**
   * A map of column indexes to their new values for this row.
   */
  public colValueMap: Map<number, string | undefined | null> = new Map();

  /**
   * The list of column indexes that were changed.
   */
  public cols: number[] = [];

  /**
   * The list of new values for the changed columns, corresponding to the `cols` array.
   */
  public values: (string | undefined | null)[] = [];

  /**
   * Additional data associated with the row change.
   */
  public data?: any;

  /**
   * The original source data for the row, if available.
   */
  public sourceData?: RateItem;

}


